import { Helper } from "../common/helper";
import { Icon, IconHelper } from "../common/icon-helper";
import { C } from "../common/component";
import { Dom } from "../common/dom";
import { Txt } from "../common/text";
import { PageInfo, PageNavigator, PageType } from "./page-navigator";
import { NavigationUrlHelper } from "./navigation-url-helper";
import { ButtonBuilder } from "../common/button-builder";
import { NavigationHelper } from "./navigation-helper";

export class TabsBuilder
{
    static async build(pageInfos: PageInfo[], selectedPage: string, parent, headerName?: string)
    {
        if (headerName)
        {
            const heading = Dom.create("h5", "header-experimental");
            heading.textContent = headerName;
            parent.append(heading);
        }

        const tabLinks = Dom.create("ul", "w-tabs");
        if (headerName)
        {
            tabLinks.classList.add("w-tabs-experimental");
        }
        parent.append(tabLinks);

        const tabContent = Dom.create("div", "w-tab-content");
        parent.append(tabContent);

        // tabPanel stays jQuery: it is handed to PageBuilder (via navigateToTab),
        // which calls jQuery methods such as .empty() on it.
        const tabItems: HTMLElement[] = [];
        const tabPanels: JQuery[] = [];

        const activateTab = (tabItem: HTMLElement, tabPanel: JQuery) =>
        {
            for (const item of tabItems)
            {
                item.classList.remove("active");
            }
            for (const panel of tabPanels)
            {
                panel.removeClass("active");
            }
            tabItem.classList.add("active");
            tabPanel.addClass("active");
        };

        let includesDashboard = false;
        for (const tab of pageInfos)
        {
            const nr = Helper.guid();
            const tabLink = Dom.create("li");
            tabLink.setAttribute("role", "presentation");
            const tabPanel = C.div
                .addClass("w-tab-pane")
                .attr("role", "tabpanel")
                .attr("id", nr)
                .appendTo(tabContent);
            tabItems.push(tabLink);
            tabPanels.push(tabPanel);

            const innerLink = Dom.add("a", tabLink);
            innerLink.setAttribute("href", `#${nr}`);
            innerLink.setAttribute("aria-controls", nr);
            IconHelper.addIconWithText(innerLink, Icon[tab.Icon], tab.DisplayName);

            // preventDefault (not `return false`) so the click still bubbles to
            // NavigationHelper's document handler, which closes the "more" dropdown
            // when a tab was opened from it.
            innerLink.addEventListener("click", async (event) =>
            {
                event.preventDefault();
                activateTab(tabLink, tabPanel);
                tabPanel.empty();
                NavigationUrlHelper.setSubPage(null);
                await PageNavigator.navigateToTab(tab.Name, tabPanel);
            });

            tabLinks.append(tabLink);

            if (selectedPage === tab.Name)
            {
                tabLink.classList.add("active");
                tabPanel.addClass("active");
                await PageNavigator.navigateToTab(tab.Name, tabPanel);
            }
            if (tab.Type === PageType.Dashboard)
            {
                includesDashboard = true;
            }
        }

        const lastTabLink = Dom.add("li", tabLinks, "w-dropdown");
        const moreToggle = Dom.add("a", lastTabLink, "w-dropdown-toggle");
        moreToggle.textContent = Txt.moreUppercase + " ";
        Dom.add("span", moreToggle, "w-caret");
        const dropdownMenu = Dom.add("ul", lastTabLink, "w-dropdown-menu", "w-dropdown-menu-right");
        NavigationHelper.registerDropdown(lastTabLink, moreToggle);

        if (!includesDashboard)
        {
            const rightTab = Dom.add("li", tabLinks, "w-tabs-right");
            // ButtonBuilder returns a jQuery element; appendTo accepts the DOM parent.
            ButtonBuilder.get({ name: Txt.toDashboard, icon: Icon.Home })
                .css({ height: "50px", borderRadius: "0" })
                .attr("role", "presentation")
                .click(async () => PageNavigator.navigateToHome()).appendTo(rightTab);
        }

        const collapseTabs = (currentHeight: number) =>
        {
            if (currentHeight > 50)
            {
                const children = tabLinks.querySelectorAll(":scope > li");
                dropdownMenu.prepend(children[children.length - 3]);
                if (children.length > 3)
                {
                    collapseTabs(tabLinks.clientHeight);
                }
            }
        };

        const height = tabLinks.clientHeight;
        if (height <= 50)
        {
            lastTabLink.style.display = "none";
        }
        else
        {
            collapseTabs(height);
        }
    }
}
